"use client"

import { useState, useEffect } from "react"
import type { CommunityBoard } from "../types"
import { useBoardStore } from "../store/board-store"
import { fetchBoards } from "../community-api"
import { dedupFetch } from "../service/request-dedup"

const BOARD_SWR = { staleTime: 30 * 60_000 } // 30 minutes

export function useBoards(): {
  boards: CommunityBoard[]
  loading: boolean
} {
  const allSlugs = useBoardStore((s) => s.allSlugs)
  const entities = useBoardStore((s) => s.entities)
  const [loading, setLoading] = useState(allSlugs.length === 0)

  useEffect(() => {
    if (allSlugs.length > 0) {
      setLoading(false)
      return
    }
    setLoading(true)
    dedupFetch(
      "boards",
      () => fetchBoards(),
      {
        ...BOARD_SWR,
        onStaleRevalidate: (fresh) => {
          if (fresh) useBoardStore.getState().setBoards(fresh)
        },
      },
    )
      .then(({ data }) => {
        if (data) useBoardStore.getState().setBoards(data)
      })
      .finally(() => setLoading(false))
  }, [allSlugs.length])

  const boards = allSlugs.map((slug) => entities[slug]).filter(Boolean)

  return { boards, loading }
}
